/// <reference path="../../app.definition.ts" />

import angular from "angular";
import { Discussion } from "@common/model/discussion";
import { DiscussionComment } from "@common/model/discussionComment";
import { JavaApiAdapterService } from "@common/apiadapter/javaapi.service";
import { CacheService } from "@common/service/cache.service";
import { IUserService } from "@common/service/user.service";


export interface IPostService {
    addComment(post: Discussion, success?: Function, error?: Function, always?: Function): ng.IPromise<DiscussionComment>;
    init(): void;
}

export class PostService implements IPostService {
    svcName: string = 'eCareVault.PostService';

    static $inject = ["$q", "ApiAdapterService", "CacheService", "UserService"];
    constructor(
        private $q: ng.IQService,
        private $_api: JavaApiAdapterService,
        private $_cache: CacheService,
        private $_user: IUserService
    ) {
    }

    addComment(post: Discussion, success?: Function, error?: Function, always?: Function): ng.IPromise<DiscussionComment> {
        let deferred: ng.IDeferred<DiscussionComment> = this.$q.defer();
        let filtered = post.currentComment.replace(/[&]nbsp[;]/gi, ""); // replace all occurrences of &nbsp with space;
            filtered = filtered.replace(/\s\s+/g, " "); // replace more than 1 space with a single space
        filtered = filtered.replace(/[<]br[^>]*[>]/gi, "");
        filtered = filtered.trim();

        if (!!filtered && filtered.length > 0) {
            var discussionComment: DiscussionComment = new DiscussionComment().deserialize({
                comment: filtered,
                commentTime: new Date().getTime(),
                sender: this.$_user.getCopyOfMe(),
                senderId: this.$_user.getMyId()
            });

            //console.debug('eCareVault.PostService: About to send comment:', discussionComment);
            var copyComment = angular.copy(discussionComment); // Just a pointer, right? why use?

            // Api call to comment
            this.$_api.createDiscussionComment(discussionComment, this.$_cache.getPassword(), post.id).then(
                (s) => {
                    deferred.resolve(copyComment);
                    !!success && success(s, copyComment);
                    !!always && always(s, copyComment);
                },
                e => {
                    deferred.reject('Error creating comment: ' + e);
                    !!error && error(e, copyComment);
                    !!always && always(e, copyComment);
                }
            );
        } else {
            deferred.reject('Nothing to post.');
        }

        return deferred.promise;

    }

    updatePostUserFormerStatus = (filteredPost, user) => {
        var deferred = this.$q.defer();
        for (let post of filteredPost) {
            let u = post.documentUsers.find((d) => d.id == user.id);
            if (!!u) {
                u["isFormerTeamMember"] = user["isFormerTeamMember"];
                user.hasOwnProperty('isActive') && (u["isActive"] = user["isActive"]);
            }
        }
        deferred.resolve(true);
        return deferred.promise;
    }

    init(): void {
    }
}
angular.module('eCareVault.common.services')
    .service('PostService', PostService);

